import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=4d20fb34&lang=pug&"
import script from "./Deposit.vue?vue&type=script&lang=ts&"
export * from "./Deposit.vue?vue&type=script&lang=ts&"
import style0 from "./Deposit.vue?vue&type=style&index=0&id=4d20fb34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports